import { Badge } from '@radix-ui/themes';
import { t } from 'i18next';
import { HitterSide } from 'lib_ts/enums/hitters.enums';
import { RADIX } from 'lib_ts/enums/radix-ui';

export const HitterSideBadge = (props: { side: HitterSide }) => {
  const isLeft = props.side === HitterSide.LHH;

  return (
    <Badge color={isLeft ? RADIX.COLOR.LEFT : RADIX.COLOR.RIGHT}>
      {t(isLeft ? 'hitters.lhh' : 'hitters.rhh')}
    </Badge>
  );
};
